import { getColumnInches } from '..';
import { isNoticeRate } from '../../types/rates';
import { floatToP2Float } from '../ui';
import { PricingFunction } from './types';

const SINGLE_COLUMN_FIRST_RUN_THRESHOLD: {
  circulationCap: number;
  costPerColumnInch: number;
}[] = [
  {
    circulationCap: 2500,
    costPerColumnInch: 5.32
  },
  {
    circulationCap: 4999,
    costPerColumnInch: 5.39
  },
  {
    circulationCap: 7499,
    costPerColumnInch: 5.53
  },
  {
    circulationCap: 9999,
    costPerColumnInch: 5.67
  },
  {
    circulationCap: 14999,
    costPerColumnInch: 5.81
  },
  {
    circulationCap: 19999,
    costPerColumnInch: 6.3
  },
  {
    circulationCap: 24999,
    costPerColumnInch: 6.79
  },
  {
    circulationCap: 29999,
    costPerColumnInch: 7.28
  },
  {
    circulationCap: 34999,
    costPerColumnInch: 7.77
  },
  {
    circulationCap: 39999,
    costPerColumnInch: 7.98
  },
  {
    circulationCap: 44999,
    costPerColumnInch: 8.19
  },
  {
    circulationCap: 49999,
    costPerColumnInch: 8.4
  },
  {
    circulationCap: 54999,
    costPerColumnInch: 8.61
  },
  {
    circulationCap: 59999,
    costPerColumnInch: 8.82
  },
  {
    circulationCap: 64999,
    costPerColumnInch: 9.03
  },
  {
    circulationCap: 69999,
    costPerColumnInch: 9.24
  },
  {
    circulationCap: 74999,
    costPerColumnInch: 9.45
  },
  {
    circulationCap: 79999,
    costPerColumnInch: 9.45
  },
  {
    circulationCap: 84999,
    costPerColumnInch: 9.66
  },
  {
    circulationCap: 89999,
    costPerColumnInch: 9.87
  },
  {
    circulationCap: 94999,
    costPerColumnInch: 10.08
  },
  {
    circulationCap: 99999,
    costPerColumnInch: 10.29
  },
  {
    circulationCap: 104999,
    costPerColumnInch: 10.5
  }
];
const SINGLE_COLUMN_ADDITIONAL_RUN_THRESHOLDS = [
  {
    circulationCap: 2500,
    costPerColumnInch: 4.06
  },
  {
    circulationCap: 4999,
    costPerColumnInch: 4.13
  },
  {
    circulationCap: 7499,
    costPerColumnInch: 4.27
  },
  {
    circulationCap: 9999,
    costPerColumnInch: 4.41
  },
  {
    circulationCap: 14999,
    costPerColumnInch: 4.55
  },
  {
    circulationCap: 19999,
    costPerColumnInch: 5.04
  },
  {
    circulationCap: 24999,
    costPerColumnInch: 5.53
  },
  {
    circulationCap: 29999,
    costPerColumnInch: 6.02
  },
  {
    circulationCap: 34999,
    costPerColumnInch: 6.51
  },
  {
    circulationCap: 39999,
    costPerColumnInch: 6.72
  },
  {
    circulationCap: 44999,
    costPerColumnInch: 6.93
  },
  {
    circulationCap: 49999,
    costPerColumnInch: 7.14
  },
  {
    circulationCap: 54999,
    costPerColumnInch: 7.35
  },
  {
    circulationCap: 59999,
    costPerColumnInch: 7.56
  },
  {
    circulationCap: 64999,
    costPerColumnInch: 7.77
  },
  {
    circulationCap: 69999,
    costPerColumnInch: 7.98
  },
  {
    circulationCap: 74999,
    costPerColumnInch: 8.19
  },
  {
    circulationCap: 79999,
    costPerColumnInch: 8.4
  },
  {
    circulationCap: 84999,
    costPerColumnInch: 8.61
  },
  {
    circulationCap: 89999,
    costPerColumnInch: 8.82
  },
  {
    circulationCap: 94999,
    costPerColumnInch: 9.03
  },
  {
    circulationCap: 99999,
    costPerColumnInch: 9.24
  },
  {
    circulationCap: 104999,
    costPerColumnInch: 9.45
  }
];

const MULTI_COLUMN_FIRST_RUN_THRESHOLD: {
  circulationCap: number;
  costPerColumnInch: number;
}[] = [
  {
    circulationCap: 2500,
    costPerColumnInch: 6.44
  },
  {
    circulationCap: 4999,
    costPerColumnInch: 6.51
  },
  {
    circulationCap: 7499,
    costPerColumnInch: 6.65
  },
  {
    circulationCap: 9999,
    costPerColumnInch: 6.79
  },
  {
    circulationCap: 14999,
    costPerColumnInch: 6.93
  },
  {
    circulationCap: 19999,
    costPerColumnInch: 7.42
  },
  {
    circulationCap: 24999,
    costPerColumnInch: 7.91
  },
  {
    circulationCap: 29999,
    costPerColumnInch: 8.4
  },
  {
    circulationCap: 34999,
    costPerColumnInch: 8.89
  },
  {
    circulationCap: 39999,
    costPerColumnInch: 9.1
  },
  {
    circulationCap: 44999,
    costPerColumnInch: 9.31
  },
  {
    circulationCap: 49999,
    costPerColumnInch: 9.52
  },
  {
    circulationCap: 54999,
    costPerColumnInch: 9.73
  },
  {
    circulationCap: 59999,
    costPerColumnInch: 9.94
  },
  {
    circulationCap: 64999,
    costPerColumnInch: 10.15
  },
  {
    circulationCap: 69999,
    costPerColumnInch: 10.36
  },
  {
    circulationCap: 74999,
    costPerColumnInch: 10.57
  },
  {
    circulationCap: 79999,
    costPerColumnInch: 10.78
  },
  {
    circulationCap: 84999,
    costPerColumnInch: 10.99
  },
  {
    circulationCap: 89999,
    costPerColumnInch: 11.2
  },
  {
    circulationCap: 94999,
    costPerColumnInch: 11.41
  },
  {
    circulationCap: 99999,
    costPerColumnInch: 11.62
  }
];

const MULTI_COLUMN_ADDITIONAL_RUN_THRESHOLDS = [
  {
    circulationCap: 2500,
    costPerColumnInch: 5.18
  },
  {
    circulationCap: 4999,
    costPerColumnInch: 5.25
  },
  {
    circulationCap: 7499,
    costPerColumnInch: 5.39
  },
  {
    circulationCap: 9999,
    costPerColumnInch: 5.53
  },
  {
    circulationCap: 14999,
    costPerColumnInch: 5.67
  },
  {
    circulationCap: 19999,
    costPerColumnInch: 6.16
  },
  {
    circulationCap: 24999,
    costPerColumnInch: 6.65
  },
  {
    circulationCap: 29999,
    costPerColumnInch: 7.14
  },
  {
    circulationCap: 34999,
    costPerColumnInch: 7.63
  },
  {
    circulationCap: 39999,
    costPerColumnInch: 7.84
  },
  {
    circulationCap: 44999,
    costPerColumnInch: 8.05
  },
  {
    circulationCap: 49999,
    costPerColumnInch: 8.26
  },
  {
    circulationCap: 54999,
    costPerColumnInch: 8.47
  },
  {
    circulationCap: 59999,
    costPerColumnInch: 8.68
  },
  {
    circulationCap: 64999,
    costPerColumnInch: 8.89
  },
  {
    circulationCap: 69999,
    costPerColumnInch: 9.1
  },
  {
    circulationCap: 74999,
    costPerColumnInch: 9.31
  },
  {
    circulationCap: 79999,
    costPerColumnInch: 9.52
  },
  {
    circulationCap: 84999,
    costPerColumnInch: 9.73
  },
  {
    circulationCap: 89999,
    costPerColumnInch: 9.94
  },
  {
    circulationCap: 94999,
    costPerColumnInch: 10.15
  },
  {
    circulationCap: 99999,
    costPerColumnInch: 10.36
  }
];

const getRelevantThresholds = ({
  runNumber,
  columns
}: {
  runNumber: number;
  columns: number;
}) => {
  if (columns === 1) {
    if (runNumber === 0) {
      return SINGLE_COLUMN_FIRST_RUN_THRESHOLD;
    }
    return SINGLE_COLUMN_ADDITIONAL_RUN_THRESHOLDS;
  }
  if (runNumber === 0) {
    return MULTI_COLUMN_FIRST_RUN_THRESHOLD;
  }
  return MULTI_COLUMN_ADDITIONAL_RUN_THRESHOLDS;
};

export const getRelevantNypaPricingForCirculation = ({
  circulation,
  runNumber,
  columns
}: {
  circulation: number;
  runNumber: number;
  columns: number;
}) => {
  const thresholds = getRelevantThresholds({ runNumber, columns });
  const sortedThresholds = thresholds.sort((a, b) =>
    a.circulationCap > b.circulationCap ? -1 : 1
  );

  const maximumThreshold = sortedThresholds[0];

  let relevantThreshold = sortedThresholds[0];

  if (circulation <= maximumThreshold.circulationCap) {
    for (const threshold of sortedThresholds) {
      if (threshold.circulationCap > relevantThreshold.circulationCap) {
        continue;
      }
      if (circulation <= threshold.circulationCap) {
        relevantThreshold = threshold;
      }
    }
  } else {
    const linesBeyondMaximumThreshold =
      circulation - maximumThreshold.circulationCap;
    const incrementsBeyondMaximumThreshold = Math.ceil(
      linesBeyondMaximumThreshold / 5_000
    );
    const incrementalCostPerColumnInch = 0.21;
    const additionalCostPerColumnInch =
      incrementsBeyondMaximumThreshold * incrementalCostPerColumnInch;
    relevantThreshold = {
      circulationCap: 164999,
      costPerColumnInch:
        maximumThreshold.costPerColumnInch + additionalCostPerColumnInch
    };
  }

  return relevantThreshold;
};

export const priceNypaStatutoryRate: PricingFunction = pricingOptions => {
  const { displayParameters, columns, runNumber, rateRecord } = pricingOptions;

  if (!isNoticeRate(rateRecord)) {
    throw new Error('NYPA statutory rate is only applicable to notice rates');
  }

  const { circulation } = rateRecord;
  const { height } = displayParameters;

  if (!columns || !circulation || !height) return 0;

  const relevantThreshold = getRelevantNypaPricingForCirculation({
    circulation,
    runNumber,
    columns
  });

  const thresholdCostInCents = relevantThreshold.costPerColumnInch * 100;

  const columnInches = getColumnInches(height, columns, rateRecord.roundOff);
  const baseCost = floatToP2Float(columnInches * thresholdCostInCents);

  return baseCost;
};
